/* eslint-disable max-len */
import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';

import FilterWithCustomQuery from './FilterWithCustomQuery';
import filterSchema from './filterSchema';

const schema: JSONSchema7 = {
    title: 'Filter With Custom Query',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        ...filterSchema.schema,
        disableTabStaticData: {
            type: 'boolean',
            title: 'Disable tabbing through static data',
            description: '',
        },
        dataSourceType: {
            type: 'string',
            title: 'Data Source Type',
            enum: ['', 'GraphQL'],
            default: '',
        },
        dataSource: {
            type: 'string',
            title: 'Data Source',
            default: '',
        },
        query: {
            type: 'string',
            title: 'Graphql query',
            description: 'A graphql query',
            default: '',
        },
        queryVariables: {
            type: 'string',
            title: 'Query variables',
            description: 'Query variables',
            default: '',
        },
        transform: {
            type: 'string',
            title: 'Transform function',
            description: 'A transform function to transform the graphql query results',
            default: '',
        },
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        'Filters Options': ['filtersUI', 'filters'],
        'Query Options': ['dataSourceType', 'dataSource', 'query', 'queryVariables', 'transform'],
        Accessibility: ['disableTabStaticData'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    ...filterSchema.uiSchema,
    disableTabStaticData: { 'ui:widget': 'CustomCheckbox' },
    dataSourceType: {
        'ui:widget': 'CustomSelect',
    },
    dataSource: {
        'ui:widget': 'CustomTextInput',
    },
    query: {
        'ui:widget': 'JSEditor',
    },
    queryVariables: {
        'ui:widget': 'JSEditor',
    },
    transform: {
        'ui:widget': 'JSEditor',
    },
};

const FilterWithCustomQueryWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: FilterWithCustomQuery,
    id: 'FilterWithCustomQuery',
    group: 'data',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default FilterWithCustomQueryWidget;
